module.exports = __webpack_public_path__ + "media/images/sp/stores/nagoya/nagoya_concept_02-73ce4e4a34e173d0b0dfb0cf338fe51d.jpg";